import React from 'react';
import { globalFiltersStore } from '../stores';

// Контекст для доступа к stores
const StoreContext = React.createContext();

/**
 * Провайдер для MobX stores
 * @param {Object} props - Свойства компонента
 * @param {React.ReactNode} props.children - Дочерние компоненты
 * @returns {React.ReactElement} Провайдер с контекстом
 */
export const StoreProvider = ({ children }) => {
  const stores = {
    globalFilters: globalFiltersStore
  };

  return (
    <StoreContext.Provider value={stores}>
      {children}
    </StoreContext.Provider>
  );
};

/**
 * Хук для доступа к stores через контекст
 * @returns {Object} Объект со всеми stores
 * @throws {Error} Если хук используется вне StoreProvider
 */
export const useStores = () => {
  const context = React.useContext(StoreContext);
  if (!context) {
    throw new Error('useStores must be used within StoreProvider');
  }
  return context;
};

/**
 * Хук для доступа к конкретному store
 * @param {string} storeName - Имя store
 * @returns {Object} Запрашиваемый store
 */
export const useStore = (storeName) => {
  const stores = useStores();
  const store = stores[storeName];
  
  if (!store) {
    throw new Error(`Store "${storeName}" not found. Available stores: ${Object.keys(stores).join(', ')}`);
  }
  
  return store;
};

/**
 * HOC для оборачивания компонентов с доступом к stores
 * @param {React.Component} Component - Компонент для оборачивания
 * @returns {React.Component} Обернутый компонент
 */
export const withStores = (Component) => {
  return (props) => (
    <StoreProvider>
      <Component {...props} />
    </StoreProvider>
  );
};
